import { Box, useMediaQuery, useTheme } from '@mui/material';

interface LogoProps {
    width?: number;
    height?: number;
}

const Logo: React.FC<LogoProps> = ({ width, height }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    // Use provided dimensions or default based on screen size
    const logoWidth = width || (isMobile ? 32 : 40);
    const logoHeight = height || (isMobile ? 32 : 40);
    
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            px: isMobile ? 0 : 2,
        }}>
            <Box 
                component="img"
                src="/logo-fox.png"
                alt="CoinTracking Logo"
                sx={{
                    width: logoWidth,
                    height: logoHeight,
                }}
            />
        </Box>
    );
};

export default Logo;
